module.exports = __webpack_public_path__ + "img/about-weeat-encounter.f7fad2f3.png";